"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Pointer = _interopRequireDefault(require("./Pointer.js"));

var _condition = require("../events/condition.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/interaction/DragRotateAndZoom
 */


/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.shiftKeyOnly}.
 * @property {number} [duration=400] Animation duration in milliseconds.
 */

/**
 * @classdesc
 * Allows the user to zoom and rotate the map by clicking and dragging
 * on the map.  By default, this interaction is limited to when the shift
 * key is held down.
 *
 * This interaction is only supported for mouse devices.
 *
 * And this interaction is not included in the default interactions.
 * @api
 */
var DragRotateAndZoom =
/** @class */
function (_super) {
  __extends(DragRotateAndZoom, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function DragRotateAndZoom(opt_options) {
    var _this = this;

    var options = opt_options ? opt_options : {};
    _this = _super.call(this,
    /** @type {import("./Pointer.js").Options} */
    options) || this;
    /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */

    _this.condition_ = options.condition ? options.condition : _condition.shiftKeyOnly;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.lastAngle_ = undefined;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.lastMagnitude_ = undefined;
    /**
     * @private
     * @type {number}
     */

    _this.lastScaleDelta_ = 0;
    /**
     * @private
     * @type {number}
     */

    _this.duration_ = options.duration !== undefined ? options.duration : 400;
    return _this;
  }
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */


  DragRotateAndZoom.prototype.handleDragEvent = function (mapBrowserEvent) {
    if (!(0, _condition.mouseOnly)(mapBrowserEvent)) {
      return;
    }

    var map = mapBrowserEvent.map;
    var size = map.getSize();
    var offset = mapBrowserEvent.pixel;
    var deltaX = offset[0] - size[0] / 2;
    var deltaY = size[1] / 2 - offset[1];
    var theta = Math.atan2(deltaY, deltaX);
    var magnitude = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    var view = map.getView();

    if (this.lastAngle_ !== undefined) {
      var angleDelta = this.lastAngle_ - theta;
      view.adjustRotationInternal(angleDelta);
    }

    this.lastAngle_ = theta;

    if (this.lastMagnitude_ !== undefined) {
      view.adjustResolutionInternal(this.lastMagnitude_ / magnitude);
    }

    if (this.lastMagnitude_ !== undefined) {
      this.lastScaleDelta_ = this.lastMagnitude_ / magnitude;
    }

    this.lastMagnitude_ = magnitude;
  };
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */


  DragRotateAndZoom.prototype.handleUpEvent = function (mapBrowserEvent) {
    if (!(0, _condition.mouseOnly)(mapBrowserEvent)) {
      return true;
    }

    var map = mapBrowserEvent.map;
    var view = map.getView();
    var direction = this.lastScaleDelta_ > 1 ? 1 : -1;
    view.endInteraction(this.duration_, direction);
    this.lastScaleDelta_ = 0;
    return false;
  };
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */


  DragRotateAndZoom.prototype.handleDownEvent = function (mapBrowserEvent) {
    if (!(0, _condition.mouseOnly)(mapBrowserEvent)) {
      return false;
    }

    if (this.condition_(mapBrowserEvent)) {
      mapBrowserEvent.map.getView().beginInteraction();
      this.lastAngle_ = undefined;
      this.lastMagnitude_ = undefined;
      return true;
    } else {
      return false;
    }
  };

  return DragRotateAndZoom;
}(_Pointer["default"]);

var _default = DragRotateAndZoom;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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